import { PractitionerDetails, PractitionerView } from '@dreryk/egabinet-personnel-frontend-api';
import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

import { defaultDayTimePreferencesInitialValues } from '../form/WaitlistForm.constants';

import { WaitlistEntryCreateFormBean } from './WaitlistEntryCreate.types';

export const getInitialValues = (
   practitioner?: PractitionerView | PractitionerDetails
): WaitlistEntryCreateFormBean => ({
   patient: null,
   urgent: false,
   location: undefined,
   note: null,
   service: null,
   reservationPreference: 'PRACTITIONER',
   videoConsultation: false,
   practitioner: practitioner ? { ...practitioner, id: PractitionerId.of(practitioner.id) } : null,
   dayTimePreferences: defaultDayTimePreferencesInitialValues,
   allDaysPreferences: false,
   dayTimePreferencesValidation: false,
});
